import Vue from 'vue';
import App from './views/app/App.vue';
import router from './router';
import store from './store/index';
import vuetify from './plugins/vuetify';
import './plugins/vuedatetimepicker';
import './plugins/vee-validate';
import axios from '@/app-axios';
import './assets/css/style.css';
import { subscribeToPush } from './utils/push';

Vue.config.productionTip = false;

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js')
    .then(async (reg) => {
      console.log('✅ Service worker registered');
    })
    .catch((err) => {
      console.error('❌ Service worker registration failed', err);
    });

  // ✅ Handle navigation triggered by notification clicks
  navigator.serviceWorker.addEventListener('message', function (event) {
    if (event.data && event.data.url) {
      const targetUrl = new URL(event.data.url, window.location.origin);
      const targetPath = targetUrl.pathname;

      if (router && router.push) {
        router.push(targetPath).catch(function (err) {
          console.warn('[Router] Navigation error:', err);
        });
      }
    }
  });
}
axios.interceptors.request.use(
  async (config) => {
    try {
      const res = await fetch('/version.json', { cache: 'no-store' });
      const data = await res.json();

      const preVersion = localStorage.getItem('appVersion');
      if (!preVersion) {
        localStorage.setItem('appVersion', data.version);
      }

      if (preVersion && preVersion !== data.version) {
        localStorage.setItem('appVersion', data.version);
      window.location.reload();
        // const app = window.__vueRoot__; // keep a global ref to App
        // if (app) {
        //   app.showUpdateDialog = true;
        // }
      }
    } catch (err) {
      console.warn('Could not fetch version.json', err);
    }
    return config;
  },
  (error) => Promise.reject(error),
);

new Vue({
  router,
  store,
  created () {
    const userInfo = localStorage.getItem('user');
    const selectedOrg = localStorage.getItem('selectedOrganization');
    localStorage.removeItem('previousSignedInAccount');
    if (userInfo) {
      const userData = JSON.parse(userInfo);
      this.$store.commit('setUserData', userData);
      const orgData = JSON.parse(selectedOrg);
      this.$store.commit('setSeletedOrganization', orgData);
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        subscribeToPush().catch((err) =>
          console.error('❌ Push subscription failed:', err),
        );
      }
    }

    const deviceInfo = localStorage.getItem('device');
    if (deviceInfo) {
      const deviceData = JSON.parse(deviceInfo);
      this.$store.commit('setDeviceData', deviceData);
    }

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response.status === 401) {
          this.$store.dispatch('logout');
        }
        return Promise.reject(error);
      },
    );
  },
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
